import { Outlet, useLocation } from 'react-router-dom';
import { lazy, Suspense } from 'react';
import { Sidebar } from './components/shell/Sidebar';
import { Topbar } from './components/shell/Topbar';
import { RightNav } from './components/shell/RightNav';
import { NewsTicker } from './components/shell/NewsTicker';
import { FeedbackDrawer } from './components/shell/FeedbackDrawer';
import { useUiStore } from '@/stores/uiStore';
import { updateCustomize } from '@/api/dashboard';

const CustomizeModal = lazy(() =>
  import('@/components/v4/CustomizeModal').then((m) => ({ default: m.CustomizeModal })),
);

const CUSTOMIZE_ITEMS = [
  { id: 'kpi-strip', label: 'KPI Strip', category: 'Overview' },
  { id: 'countdown', label: 'Deadline Countdown', category: 'Overview' },
  { id: 'state-comparison', label: 'State Comparison', category: 'National' },
  { id: 'national-bars', label: 'National Summary Bars', category: 'National' },
  { id: 'sparklines', label: 'Trend Sparklines', category: 'Trends' },
];

export function App() {
  const location = useLocation();
  const panelId = location.pathname.split('/')[1] || 'dashboard';
  const customizeOpen = useUiStore((s) => s.customizeModalOpen);
  const closeCustomize = useUiStore((s) => s.closeCustomizeModal);

  const handleSaveCustomize = async (selected: string[]) => {
    try {
      await updateCustomize({ selectedItems: selected });
    } catch {
      /* ignore; panel renders empty state if backend unavailable */
    }
    closeCustomize();
  };

  return (
    <div style={{ display: 'flex', height: '100vh', overflow: 'hidden' }}>
      <a href="#main-content" className="sr-only" style={{ position: 'absolute', zIndex: 1000 }}>
        Skip to main content
      </a>
      <Sidebar />
      <div style={{ flex: 1, display: 'flex', flexDirection: 'column', minWidth: 0 }}>
        <Topbar panelId={panelId} />
        <main
          id="main-content"
          style={{ flex: 1, overflowY: 'auto', padding: '24px 32px' }}
        >
          <Outlet />
        </main>
        <NewsTicker />
      </div>
      <RightNav />
      <FeedbackDrawer />
      <Suspense fallback={null}>
        <CustomizeModal
          isOpen={customizeOpen}
          onClose={closeCustomize}
          onSave={handleSaveCustomize}
          availableItems={CUSTOMIZE_ITEMS}
          initialSelected={CUSTOMIZE_ITEMS.map((i) => i.id)}
        />
      </Suspense>
    </div>
  );
}
